require('/ui/components/taskflow/layoutHeader/layoutHeader.module.scss.module.css');

export const container = "_container_yvons_1";
export const icon = "_icon_yvons_1";
export const titleContainer = "_title-container_yvons_1";
export const title = "_title_yvons_1";
export const smallViewportSupport = "_small-viewport-support_yvons_1";
export const description = "_description_yvons_1";
export const mobileLayout = "_mobile-layout_yvons_1";
export const resourcelink = "_resourcelink_yvons_1";
export const resourcelinkDisplayText = "_resourcelink-display-text_yvons_1";
export const headerCtas = "_header-ctas_yvons_1";
export const cta = "_cta_yvons_1";
